// Kit Diario — JS propio, vanilla, sin librerias externas.
// La bandera evita registrar una segunda inicializacion si este asset se
// incluyera accidentalmente mas de una vez en el futuro.
if (!window.__mtScriptsRegistered) {
  window.__mtScriptsRegistered = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initEscenaDia();
    initGaleriaProducto();
    initSelectorVariantes();
    initFaq();
    initContadores();
    initKitDiario();
    initMochilaParallax();
    initConectoresSistema();
    initHotspotsEngineering();
  }, { once: true });
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// ---------- Reveals al hacer scroll ----------
function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  // Red de seguridad: si algo falla y un elemento nunca entra en pantalla
  // (o el observer no llega a dispararse), no debe quedar invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 4000);
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.dataset.mtDelay || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, delay);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el, i) {
    el.dataset.mtDelay = (i % 4) * 90;
    obs.observe(el);
  });
}

// ---------- Escena sticky de "Dia ordenado" ----------
function initEscenaDia() {
  var secciones = document.querySelectorAll('[data-mt-dia]');
  secciones.forEach(function (raiz) {
    var pasos = raiz.querySelectorAll('[data-mt-paso]');
    var imgs = raiz.querySelectorAll('[data-mt-visual]');
    if (!pasos.length || !imgs.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = entry.target.dataset.mtPaso;
          imgs.forEach(function (img) {
            img.classList.toggle('mt-visual-activa', img.dataset.mtVisual === idx);
          });
        }
      });
    }, { threshold: 0.55 });
    pasos.forEach(function (p) { obs.observe(p); });
  });
}

// ---------- Galeria de producto (miniaturas) ----------
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-miniatura]');
    var mochilaColorMap = galeria.querySelector('.mt-mochila-color-map');
    var laptopColorMap = galeria.querySelector('.mt-laptop-color-map');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.dataset.mtMiniatura;
        var img = principal.querySelector('img');
        if (img && src) img.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
        mini.classList.add('mt-miniatura-activa');
        if (mochilaColorMap) mochilaColorMap.hidden = !mini.hasAttribute('data-mt-color-map-main');
        if (laptopColorMap) laptopColorMap.hidden = !mini.hasAttribute('data-mt-laptop-map-main');
        if (mini.dataset.mtColor && mini.dataset.mtColor !== 'Todos') {
          var opcionesColor = galeria.closest('.mt-producto').querySelectorAll('[data-mt-opcion]');
          opcionesColor.forEach(function (opcion) {
            if (opcion.dataset.mtValor === mini.dataset.mtColor) opcion.click();
          });
        }
      });
    });
  });
}

// ---------- Selector de variantes simple ----------
function initSelectorVariantes() {
  var wraps = document.querySelectorAll('[data-mt-producto-form]');
  wraps.forEach(function (wrap) {
    var selectNativo = wrap.querySelector('[data-mt-select-variante]');
    var grupos = wrap.querySelectorAll('.mt-producto__variante-grupo[data-mt-grupo]');
    var orgSelector = wrap.querySelector('[data-mt-organizador-selector]');
    if (!selectNativo) return;

    var opciones = JSON.parse(selectNativo.dataset.mtVariantes || '[]');

    if (orgSelector) {
      var productoOrg = wrap.closest('.mt-producto');
      var sizeBtns = orgSelector.querySelectorAll('[data-mt-org-size]');
      var colorBtns = orgSelector.querySelectorAll('[data-mt-org-color]');
      var varianteOrgInicial = opciones.find(function (v) { return String(v.id) === String(selectNativo.value); }) || opciones[0];
      var claveInicial = varianteOrgInicial ? varianteOrgInicial.opciones[0] : 'Black';
      var sizeActual = /28X21X9CM$/i.test(claveInicial) ? 'large' : 'standard';
      var colorActual = claveInicial.replace(/28X21X9CM$/i, '').replace(/^Grey$/i, 'Gray');

      function claveOrganizador(color, size) {
        if (size === 'standard') return color;
        return (color === 'Gray' ? 'Grey' : color) + '28X21X9CM';
      }

      function aplicarOrganizador() {
        var clave = claveOrganizador(colorActual, sizeActual);
        var match = opciones.find(function (v) { return v.opciones[0] === clave; });
        if (!match) return;
        selectNativo.value = match.id;
        sizeBtns.forEach(function (b) { b.classList.toggle('mt-opcion-activa', b.dataset.mtOrgSize === sizeActual); });
        colorBtns.forEach(function (b) { b.classList.toggle('mt-opcion-activa', b.dataset.mtOrgColor === colorActual); });
        var sizeLabel = orgSelector.querySelector('[data-mt-org-size-label]');
        var colorLabel = orgSelector.querySelector('[data-mt-org-color-label]');
        var colorActivo = orgSelector.querySelector('[data-mt-org-color="' + colorActual + '"]');
        if (sizeLabel) sizeLabel.textContent = ': ' + (sizeActual === 'large' ? 'Grande' : 'Estándar');
        if (colorLabel && colorActivo) colorLabel.textContent = ': ' + colorActivo.textContent.trim();
        var mini = productoOrg.querySelector('[data-mt-organizador-color="' + colorActual + '"]');
        var imagen = productoOrg.querySelector('[data-mt-galeria-principal] img');
        var mapa = productoOrg.querySelector('.mt-organizador-color-map');
        if (mini && imagen) {
          imagen.src = sizeActual === 'large' ? mini.dataset.mtImgLarge : mini.dataset.mtImgStandard;
          productoOrg.classList.add('mt-organizador-modo-detalle');
          productoOrg.querySelectorAll('[data-mt-organizador-color]').forEach(function (m) { m.classList.toggle('mt-miniatura-activa', m === mini); });
          if (mapa) mapa.hidden = true;
          productoOrg.querySelectorAll('[data-mt-org-map-color]').forEach(function (zona) {
            zona.classList.toggle('mt-org-map-activa', zona.dataset.mtOrgMapColor === colorActual && zona.dataset.mtOrgMapSize === sizeActual);
          });
        }
        var precioEl = productoOrg.querySelector('[data-mt-precio-actual]');
        if (precioEl) precioEl.textContent = match.precio;
        var addBtn = wrap.querySelector('[data-mt-add]');
        if (addBtn) {
          addBtn.disabled = !match.disponible;
          var span = addBtn.querySelector('span');
          if (span) span.textContent = match.disponible ? addBtn.dataset.mtTextoComprar : addBtn.dataset.mtTextoAgotado;
        }
        if (window.history && window.history.replaceState) window.history.replaceState({}, '', window.location.pathname + '?variant=' + match.id + '&view=mt-organizador');
      }

      sizeBtns.forEach(function (btn) { btn.addEventListener('click', function () { sizeActual = btn.dataset.mtOrgSize; aplicarOrganizador(); }); });
      colorBtns.forEach(function (btn) { btn.addEventListener('click', function () { colorActual = btn.dataset.mtOrgColor; aplicarOrganizador(); }); });
      productoOrg.querySelectorAll('[data-mt-organizador-color]').forEach(function (mini) { mini.addEventListener('click', function () { colorActual = mini.dataset.mtOrganizadorColor; aplicarOrganizador(); }); });
      productoOrg.querySelectorAll('[data-mt-org-map-color]').forEach(function (zona) { zona.addEventListener('click', function () { colorActual = zona.dataset.mtOrgMapColor; sizeActual = zona.dataset.mtOrgMapSize; aplicarOrganizador(); }); });
      var miniTodos = productoOrg.querySelector('[data-mt-org-map-main]');
      if (miniTodos) miniTodos.addEventListener('click', function () {
        var imagen = productoOrg.querySelector('[data-mt-galeria-principal] img');
        var mapa = productoOrg.querySelector('.mt-organizador-color-map');
        if (imagen) imagen.src = miniTodos.dataset.mtMiniatura;
        if (mapa) mapa.hidden = false;
        productoOrg.classList.remove('mt-organizador-modo-detalle');
        productoOrg.querySelectorAll('[data-mt-miniatura]').forEach(function (m) { m.classList.toggle('mt-miniatura-activa', m === miniTodos); });
        productoOrg.querySelectorAll('[data-mt-org-map-color]').forEach(function (zona) { zona.classList.remove('mt-org-map-activa'); });
      });
      if (new URLSearchParams(window.location.search).has('variant')) {
        aplicarOrganizador();
      } else {
        var sizeLabelInicial = orgSelector.querySelector('[data-mt-org-size-label]');
        var colorLabelInicial = orgSelector.querySelector('[data-mt-org-color-label]');
        if (sizeLabelInicial) sizeLabelInicial.textContent = ': Estándar';
        if (colorLabelInicial) colorLabelInicial.textContent = ': Negro';
      }
      return;
    }

    if (!grupos.length) return;

    // El ID del input nativo es la fuente de verdad. Alineamos cada grupo
    // visual con esa variante antes de permitir cualquier interaccion.
    var varianteInicial = opciones.find(function (v) {
      return String(v.id) === String(selectNativo.value);
    });
    if (varianteInicial) {
      grupos.forEach(function (g, index) {
        g.querySelectorAll('[data-mt-opcion]').forEach(function (btn) {
          btn.classList.toggle('mt-opcion-activa', btn.dataset.mtValor === varianteInicial.opciones[index]);
        });
      });
    }

    function seleccionActual() {
      var seleccion = {};
      grupos.forEach(function (g) {
        var activo = g.querySelector('.mt-opcion-activa');
        if (activo) seleccion[g.dataset.mtGrupo] = activo.dataset.mtValor;
      });
      return seleccion;
    }

    // Marca sin stock los valores que, combinados con lo ya elegido en los
    // demas grupos, no llevan a ninguna variante disponible — asi nunca se
    // puede seleccionar una combinacion inexistente o agotada sin avisar.
    function actualizarDisponibilidadBotones() {
      var seleccion = seleccionActual();
      grupos.forEach(function (g) {
        var miGrupo = g.dataset.mtGrupo;
        g.querySelectorAll('[data-mt-opcion]').forEach(function (btn) {
          var prueba = Object.assign({}, seleccion);
          prueba[miGrupo] = btn.dataset.mtValor;
          var existe = opciones.some(function (v) {
            return v.opciones.every(function (o, i) { return prueba[i] === undefined || prueba[i] === o; });
          });
          var disponible = opciones.some(function (v) {
            if (!v.disponible) return false;
            return v.opciones.every(function (o, i) { return prueba[i] === undefined || prueba[i] === o; });
          });
          btn.disabled = !existe;
          btn.classList.toggle('mt-opcion-agotada', existe && !disponible);
        });
        var valorEl = g.querySelector('[data-mt-grupo-valor]');
        var activo = g.querySelector('.mt-opcion-activa');
        if (valorEl && activo) valorEl.textContent = ': ' + activo.dataset.mtValor;
      });
    }

    function aplicarSeleccion() {
      var seleccion = seleccionActual();
      var match = opciones.find(function (v) {
        return v.opciones.every(function (o, i) { return seleccion[i] === o; });
      });
      if (!match) return;
      selectNativo.value = match.id;
      var producto = wrap.closest('.mt-producto');
      var esBotella = producto && producto.dataset.mtProductHandle === 'outdoor-collapsible-water-bottle-water-cup';
      var esLaptop = producto && producto.dataset.mtProductHandle === 'laptop-sleeve-with-stand-fits-various-computers';
      if (esBotella || esLaptop) {
        if (window.history && window.history.replaceState) {
          var vista = esLaptop ? '&view=mt-laptop' : '';
          window.history.replaceState({}, '', window.location.pathname + '?variant=' + match.id + vista);
        }
        var galeria = producto.querySelector('[data-mt-galeria]');
        var colorElegido = match.opciones[0];
        if (galeria && colorElegido) {
          var miniColor = galeria.querySelector('[data-mt-color="' + colorElegido + '"]');
          var imagenPrincipal = galeria.querySelector('[data-mt-galeria-principal] img');
          if (miniColor && imagenPrincipal) {
            imagenPrincipal.src = miniColor.dataset.mtMiniatura;
            var laptopColorMap = galeria.querySelector('.mt-laptop-color-map');
            if (laptopColorMap && esLaptop) laptopColorMap.hidden = true;
            galeria.querySelectorAll('[data-mt-miniatura]').forEach(function (m) {
              m.classList.toggle('mt-miniatura-activa', m === miniColor);
            });
          }
        }
      }
      var precioEl = producto ? producto.querySelector('[data-mt-precio-actual]') : null;
      if (precioEl) precioEl.textContent = match.precio;
      var addBtn = wrap.querySelector('[data-mt-add]');
      if (addBtn) {
        addBtn.disabled = !match.disponible;
        var span = addBtn.querySelector('span');
        var texto = match.disponible ? addBtn.dataset.mtTextoComprar : addBtn.dataset.mtTextoAgotado;
        if (span) span.textContent = texto; else addBtn.textContent = texto;
      }
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('[data-mt-opcion]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var grupo = btn.dataset.mtGrupo;
          wrap.querySelectorAll('[data-mt-grupo="' + grupo + '"]').forEach(function (b) {
            b.classList.remove('mt-opcion-activa');
          });
          btn.classList.add('mt-opcion-activa');
          actualizarDisponibilidadBotones();
          aplicarSeleccion();
        });
      });
    });

    actualizarDisponibilidadBotones();
    aplicarSeleccion();
  });
}

// ---------- FAQ acordeon ----------
function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      items.forEach(function (i) {
        i.classList.remove('mt-faq-abierto');
        i.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-faq-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

// ---------- Contadores animados ----------
function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.dataset.mtContador);
      var decimales = (el.dataset.mtContador.split('.')[1] || '').length;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      if (prefersReducedMotion()) { el.textContent = fin.toFixed(decimales); }
      else requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

// ---------- El Kit Diario: selectores de variante reales + carrito nativo de Dawn ----------
function initKitDiario() {
  var formularios = document.querySelectorAll('[data-mt-kit-form]');
  if (!formularios.length) return;

  formularios.forEach(function (form) {
    var moneda = form.dataset.mtMoneda || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    // Se fuerza el formato en-US ($1,234.56) para que coincida con el resto de
    // precios de la tienda, que Shopify siempre renderiza en ese formato aunque
    // el idioma activo de la pagina sea otro.
    var formateador;
    try {
      formateador = new Intl.NumberFormat('en-US', { style: 'currency', currency: moneda });
    } catch (e) {
      formateador = { format: function (n) { return '$' + n.toFixed(2); } };
    }

    var productos = form.querySelectorAll('[data-mt-kit-producto]');
    var estados = []; // { el, disponible, precioActual, precioEl, avisoEl, selects, variantes }

    productos.forEach(function (productoEl) {
      var disponibleProducto = productoEl.dataset.mtKitDisponible === 'true';
      var selectVariantes = productoEl.querySelector('[data-mt-kit-variantes]');
      var opciones = Array.prototype.map.call(selectVariantes ? selectVariantes.options : [], function (opt) {
        return {
          id: opt.value,
          opciones: (opt.dataset.opciones || '').split('///'),
          precioCentavos: parseInt(opt.dataset.precioCentavos, 10) || 0,
          disponible: opt.dataset.disponible === 'true',
          selected: opt.selected
        };
      });
      var actual = opciones.filter(function (o) { return o.selected; })[0] || opciones[0];

      var estado = {
        el: productoEl,
        disponibleProducto: disponibleProducto,
        actual: actual,
        precioEl: productoEl.querySelector('[data-mt-kit-precio]'),
        avisoEl: productoEl.querySelector('[data-mt-kit-aviso-variante]'),
        selects: Array.prototype.slice.call(productoEl.querySelectorAll('[data-mt-kit-opcion]')),
        opciones: opciones
      };
      estados.push(estado);

      // Los selects visibles deben representar exactamente la variante que
      // Shopify ha elegido como selected_or_first_available_variant.
      if (actual) {
        estado.selects.forEach(function (select, index) {
          if (actual.opciones[index] !== undefined) select.value = actual.opciones[index];
        });
      }

      var orgColor = productoEl.querySelector('[data-mt-kit-org-color]');
      var orgSize = productoEl.querySelector('[data-mt-kit-org-size]');
      function separarOrganizador(valor) {
        var grande = /28X21X9CM$/i.test(valor || '');
        var color = (valor || '').replace(/28X21X9CM$/i, '').replace(/^Grey$/i, 'Gray');
        return { color: color, size: grande ? 'large' : 'standard' };
      }
      function valorOrganizador(color, size) {
        if (size === 'large') return (color === 'Gray' ? 'Grey' : color) + '28X21X9CM';
        return color;
      }
      if (orgColor && orgSize && actual) {
        var orgInicial = separarOrganizador(actual.opciones[0]);
        orgColor.value = orgInicial.color;
        orgSize.value = orgInicial.size;
        var sincronizarOrganizador = function () {
          estado.selects[0].value = valorOrganizador(orgColor.value, orgSize.value);
          estado.selects[0].dispatchEvent(new Event('change', { bubbles: true }));
        };
        orgColor.addEventListener('change', sincronizarOrganizador);
        orgSize.addEventListener('change', sincronizarOrganizador);
      }

      if (estado.precioEl && actual) estado.precioEl.textContent = formateador.format(actual.precioCentavos / 100);
      actualizarAvisoVariante(estado);

      estado.selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var seleccion = estado.selects.map(function (s) { return s.value; });
          var match = estado.opciones.filter(function (o) {
            return o.opciones.every(function (val, i) { return val === seleccion[i]; });
          })[0];
          if (!match) return;
          estado.actual = match;
          if (estado.precioEl) estado.precioEl.textContent = formateador.format(match.precioCentavos / 100);
          actualizarAvisoVariante(estado);
          actualizarTotal();
          actualizarBoton();
        });
      });
    });

    function actualizarAvisoVariante(estado) {
      if (!estado.avisoEl) return;
      var ok = estado.actual && estado.actual.disponible;
      estado.avisoEl.hidden = !!ok;
    }

    function totalDisponible() {
      return estados.every(function (e) { return e.disponibleProducto && e.actual && e.actual.disponible; });
    }

    function actualizarTotal() {
      var totalEl = form.querySelector('[data-mt-kit-total]');
      if (!totalEl) return;
      var sumaCentavos = estados.reduce(function (acc, e) { return acc + (e.actual ? e.actual.precioCentavos : 0); }, 0);
      totalEl.textContent = formateador.format(sumaCentavos / 100);
    }

    function actualizarBoton() {
      var btn = form.querySelector('[data-mt-kit-add]');
      if (!btn) return;
      var listo = totalDisponible();
      btn.disabled = !listo;
      btn.classList.toggle('mt-kit__boton--deshabilitado', !listo);
    }

    actualizarTotal();
    actualizarBoton();

    // ---------- Boton de anadir el kit ----------
    var btn = form.querySelector('[data-mt-kit-add]');
    if (!btn) return;
    var textoOriginal = btn.dataset.mtKitTextoOriginal || btn.textContent.trim();
    var enviando = false;

    btn.addEventListener('click', function () {
      if (enviando || btn.disabled) return;
      if (!totalDisponible()) return;

      var items = estados.map(function (e) { return { id: e.actual.id, quantity: 1 }; });
      var aviso = form.querySelector('[data-mt-kit-aviso]');
      if (aviso) aviso.textContent = '';

      enviando = true;
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = btn.dataset.mtKitCargando || 'Añadiendo...';

      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var seccionesPedidas = cartEl && typeof cartEl.getSectionsToRender === 'function'
        ? cartEl.getSectionsToRender().map(function (s) { return s.id; })
        : [];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: seccionesPedidas,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (resultado) {
          if (!resultado.ok || resultado.data.status) {
            throw resultado.data;
          }
          var data = resultado.data;
          if (cartEl && typeof cartEl.renderContents === 'function' && data.items && data.items.length) {
            data.key = data.items[data.items.length - 1].key;
            cartEl.renderContents(data);
          } else {
            // Sin cart-notification/cart-drawer en la pagina: al menos confirmamos por texto, sin recargar.
            if (aviso) aviso.textContent = 'Kit añadido a tu carrito.';
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function (err) {
          if (aviso) {
            var msg = (err && (err.description || err.message)) || 'Algún producto del kit no tiene stock suficiente ahora mismo. Prueba a añadir cada producto por separado.';
            aviso.textContent = msg;
          }
        })
        .finally(function () {
          enviando = false;
          btn.disabled = !totalDisponible();
          btn.removeAttribute('aria-disabled');
          btn.textContent = textoOriginal;
        });
    });
  });
}

// ---------- Mochila: rotacion 3D al mouse + parallax de los 3 productos ----------
// Solo aplica en escritorio con mouse real (hover + puntero fino). En
// tablet/movil y con prefers-reduced-motion queda completamente estatica —
// no se añade ningun listener ni animacion.
function initMochilaParallax() {
  var escenarios = document.querySelectorAll('[data-mt-parallax]');
  if (!escenarios.length) return;
  if (prefersReducedMotion()) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  escenarios.forEach(function (stage) {
    var mochila = stage.querySelector('[data-mt-parallax-mochila]');
    var items = stage.querySelectorAll('[data-mt-parallax-item]');
    if (!mochila) return;

    var targetX = 0; // -1 a 1
    var targetY = 0; // -1 a 1
    var ticking = false;
    var MAX_ROTATE_Y = 12; // grados
    var MAX_ROTATE_X = 4; // grados
    var MAX_SCALE_EXTRA = 0.02; // 1.02 base + hasta 0.02 extra = 1.04
    var MAX_PARALLAX_PX = 16;

    function quitarTransicion() {
      mochila.classList.remove('mt-parallax-retorno');
      items.forEach(function (it) { it.classList.remove('mt-parallax-retorno'); });
    }

    function aplicar() {
      ticking = false;
      var magnitud = Math.min(Math.abs(targetX) + Math.abs(targetY), 1);
      var rotY = (targetX * MAX_ROTATE_Y).toFixed(2);
      var rotX = (targetY * -MAX_ROTATE_X).toFixed(2);
      var escala = (1.02 + magnitud * MAX_SCALE_EXTRA).toFixed(3);
      mochila.style.transform =
        'rotateY(' + rotY + 'deg) rotateX(' + rotX + 'deg) scale(' + escala + ')';

      items.forEach(function (item) {
        var factor = parseFloat(item.dataset.mtParallaxFactor) || 0.3;
        var px = (targetX * MAX_PARALLAX_PX * factor).toFixed(2);
        var py = (targetY * MAX_PARALLAX_PX * factor).toFixed(2);
        item.style.transform = 'translate3d(' + px + 'px, ' + py + 'px, 0)';
      });
    }

    function solicitarFrame() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(aplicar);
      }
    }

    stage.addEventListener('mousemove', function (evt) {
      quitarTransicion();
      var rect = stage.getBoundingClientRect();
      var relX = ((evt.clientX - rect.left) / rect.width) * 2 - 1;
      var relY = ((evt.clientY - rect.top) / rect.height) * 2 - 1;
      targetX = Math.max(-1, Math.min(1, relX));
      targetY = Math.max(-1, Math.min(1, relY));
      solicitarFrame();
    });

    stage.addEventListener('mouseleave', function () {
      targetX = 0;
      targetY = 0;
      mochila.classList.add('mt-parallax-retorno');
      items.forEach(function (it) { it.classList.add('mt-parallax-retorno'); });
      solicitarFrame();
    });
  });
}

// ---------- Escena 02: conectores editoriales (dibujo al entrar en vista) ----------
function initConectoresSistema() {
  var items = document.querySelectorAll('.mt-sistema__item');
  if (!items.length) return;
  if (typeof IntersectionObserver === 'undefined') {
    items.forEach(function (it) { it.classList.add('mt-conector-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-conector-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  items.forEach(function (it) { obs.observe(it); });
}

// ---------- Escena 03: hotspots de product engineering ----------
function initHotspotsEngineering() {
  var stages = document.querySelectorAll('.mt-engineering__visual');
  stages.forEach(function (stage) {
    var wrap = stage.closest('.mt-engineering__stage');
    if (!wrap) return;
    var hotspots = stage.querySelectorAll('[data-mt-hotspot]');
    var notas = wrap.querySelectorAll('[data-mt-hotspot-nota]');
    var numero = stage.querySelector('[data-mt-hotspot-numero]');
    var titulo = stage.querySelector('[data-mt-hotspot-titulo]');
    var texto = stage.querySelector('[data-mt-hotspot-texto]');

    function activar(id) {
      hotspots.forEach(function (h) {
        var activo = h.dataset.mtHotspot === id;
        h.classList.toggle('mt-hotspot-activo', activo);
        h.setAttribute('aria-expanded', activo ? 'true' : 'false');
      });
      notas.forEach(function (n) { n.classList.toggle('mt-hotspot-activo', n.dataset.mtHotspotNota === id); });
      var nota = wrap.querySelector('[data-mt-hotspot-nota="' + id + '"]');
      if (nota) {
        if (numero) numero.textContent = String(id).padStart(2, '0');
        if (titulo) titulo.textContent = nota.dataset.mtTitulo;
        if (texto) texto.textContent = nota.dataset.mtTexto;
      }
    }

    hotspots.forEach(function (h) {
      h.addEventListener('mouseenter', function () { activar(h.dataset.mtHotspot); });
      h.addEventListener('click', function () { activar(h.dataset.mtHotspot); });
      h.addEventListener('focus', function () { activar(h.dataset.mtHotspot); });
    });
    notas.forEach(function (n) {
      n.addEventListener('click', function () { activar(n.dataset.mtHotspotNota); });
    });
    activar('1');
  });
}
